import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  FetchAppNotificationPayload,
  IAppNotification,
  UnreadNotificationResponse,
  UpdateNotificationPayload,
} from '../types/app-notification.type';

export const appNotificationApi = createApi({
  reducerPath: 'appNotificationApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/notifications`),
  endpoints: (builder) => ({
    fetchNotifications: builder.query<ApiPaginationResponse<IAppNotification[]>, FetchAppNotificationPayload>({
      query: (params) => ({
        url: '',
        method: 'GET',
        params,
      }),
    }),
    getUnreadNotificationCount: builder.query<ApiResponse<UnreadNotificationResponse>, void>({
      query: () => ({
        url: '/unread',
        method: 'GET',
      }),
    }),
    markAllAsRead: builder.query<ApiResponse<any>, void>({
      query: () => ({
        url: '/mark-all-as-read',
        method: 'POST',
      }),
    }),
    updateNotification: builder.mutation<ApiResponse<IAppNotification>, UpdateNotificationPayload>({
      query: (payload) => ({
        url: `/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyFetchNotificationsQuery,
  useLazyGetUnreadNotificationCountQuery,
  useUpdateNotificationMutation,
  useLazyMarkAllAsReadQuery,
} = appNotificationApi;
